import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["submitButton"];
  static values = {
    currentStep: String,
    formUuid: String
  }
  
  connect() {
    const url = new URL(window.location.href)

    url.searchParams.set("current_step", this.currentStepValue)
    url.searchParams.set("uuid", this.formUuidValue)
    window.history.replaceState({}, "", url)

    this.enableSubmit();
  }

  enableSubmit() {
    const stepChecks = {
      'country': () => this.checkFieldNotEmpty('#co_sponsor_form_country'),
      'self_identity': () => this.checkFieldNotEmpty('#co_sponsor_form_agent_name') && document.querySelector('#verify-valid-agent-checkbox').checked,
      'co_sponsor_info': () => this.checkFieldNotEmpty('#co_sponsor_form_co_sponsor_name') && document.querySelector('#verify-valid-co-sponsor-checkbox').checked,
      'action': () => this.checkStepThreeValidity()
    };

    // if stepChecks not present then return true, which means button enabled
    if (stepChecks[this.currentStepValue] == undefined) { return true } 
  
    if (stepChecks[this.currentStepValue]()) {
      this.submitButtonTarget.classList.remove('disabled');
      this.submitButtonTarget.removeAttribute("disabled");
    } else {
      this.submitButtonTarget.classList.add('disabled');
      this.submitButtonTarget.setAttribute("disabled", "disabled");
    }
  }

  checkStepThreeValidity() {
    const nameCoSponsorInput = document.querySelector("#co_sponsor_form_action_name_a_co_sponsor");
    if (nameCoSponsorInput && nameCoSponsorInput.checked) {
      return true;
    }

    const changeCoSponsorInput = document.querySelector("#co_sponsor_form_action_change_an_existing_co_sponsor");
    if (changeCoSponsorInput && changeCoSponsorInput.checked) {
      const changedCoSponsorPreviouslyInput = document.querySelector("#co_sponsor_form_co_sponsor_changed_previously");
      const changeReasonSelector = '#co_sponsor_form_change_reason:not([disabled])';

      if (changedCoSponsorPreviouslyInput.value === "true") {
        return this.checkFieldsNotEmpty('#co_sponsor_form_how_many_times_changed', changeReasonSelector);
      } else if (changedCoSponsorPreviouslyInput.value === "false") {
        return this.checkFieldNotEmpty(changeReasonSelector);
      }
      return false;
    }

    const removeCoSponsorInput = document.querySelector("#co_sponsor_form_action_remove_a_co_sponsor");
    if (removeCoSponsorInput && removeCoSponsorInput.checked) {
      const removeCoSponsorConfirmationInput = document.querySelector("#remove-co-sponsor-confirmation");
      return this.checkFieldNotEmpty('#co_sponsor_form_change_reason:not([disabled])') && removeCoSponsorConfirmationInput.checked;
    }

    return false;
  }

  
  checkFieldNotEmpty(selector) {
    const field = document.querySelector(selector);
    return field && field.value.trim() !== '';
  }

  checkFieldsNotEmpty(...selectors) {
    return selectors.every(selector => this.checkFieldNotEmpty(selector));
  }
}
